import { render, staticRenderFns } from "./WhitePaper.vue?vue&type=template&id=3bdcf972&scoped=true&"
import script from "./WhitePaper.vue?vue&type=script&lang=js&"
export * from "./WhitePaper.vue?vue&type=script&lang=js&"
import style0 from "./WhitePaper.vue?vue&type=style&index=0&id=3bdcf972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdcf972",
  null
  
)

export default component.exports